function focusIndicator(rootElement) {
  const focusAttr = 'data-focus-method'
  let focusMethod
  let lastFocusMethod

  rootElement.addEventListener('touchstart', () => {
    focusMethod = 'touch'
  })

  rootElement.addEventListener('mousedown', () => {
    if (focusMethod === 'touch') {
      return
    }
    focusMethod = 'mouse'
  })

  rootElement.addEventListener('keydown', () => {
    focusMethod = 'key'
  })

  rootElement.addEventListener('focusin', (event) => {
    if (focusMethod === 'key') {
      const elementName = event.target.nodeName.toLowerCase()
      if ((elementName !== 'input' && elementName !== 'textarea') || focusMethod === lastFocusMethod) {
        event.target.setAttribute(focusAttr, focusMethod)
      }
    }
  })

  rootElement.addEventListener('focusout', (event) => {
    const elementName = event.target.nodeName.toLowerCase()
    event.target.removeAttribute(focusAttr)

    if (elementName !== 'input' && elementName !== 'textarea') {
      lastFocusMethod = focusMethod
    }
  })
}

export default focusIndicator
